// SPDX-License-Identifier: MIT
/** Mini runtime; declarations are generated from the server schema without changing its entrypoint. */
export * from './brand.ts';
export * from './reel.ts';
export * from './player.ts';
export * from '../patch.ts';

import { config } from 'zod/mini';
import { en } from 'zod/locales';
config(en());
